import IntroSlider from "../components/Intro/IntroSlider";
import InitialPreferences from "../containers/Preferences/InitialPreferences";
import MainPopularMixes from "../containers/Main/PopularMixesPage";
import MainPopularMix from "../containers/Main/PopularMixPage";
import MainListCompilation from "../containers/Main/ListCompilationsPage";
import ForYouMix from "../containers/ForYou/ForYouMix";
import FavoriteContainer from "../containers/Favorite/FavoriteContainer";
import MainMixCompilation from "../containers/Main/MixCompilationPage";
import MixerRandomMix from "../containers/Mixer/RandomMixPage";
import MixerCatalogBrands from "../containers/Mixer/CatalogBrandsPage";
import TastesBrandContainer from "../containers/Mixer/TastesBrandPage";
import MixerNowContainer from "../containers/Mixer/MixerNowPage";
import MixerMixPage from "../containers/Mixer/MixerMixPage";
import MixerMainPage from "../containers/Mixer/MixerMainPage";
import MixerResultContainer from "../containers/Mixer/MixerResultPage";
import MainPage from "../containers/Main/MainPage";
import MixWeekPage from "../containers/Main/MixWeekPage";
import ChangePreferences from "../containers/Main/ChangePreferences";
import SelectionPreferences from "../containers/Mixer/SelectionPreferences";
import FavoriteMixPage from "../containers/Favorite/FavoriteMixPage";
import MixerPreferencesContainer from "../containers/Mixer/MixerPreferencesContainer";
import MixPreferencesPage from "../containers/Mixer/MixPreferencesPage";
import ListMixesCompilationPage from "../containers/Main/ListMixesCompilationPage";
import ForYouPreferences from "../containers/Main/ForYouPreferences";
import {IRoute} from "../constants/types";
import SharedMix from "../containers/SharedMix";

export const routesArray: Array<IRoute> = [
    {
        path: '/',
        exact: true,
        component: IntroSlider,
    },
    {
        path: '/start',
        component: InitialPreferences,
    },
    {
        path: '/main',
        exact: true,
        component: MainPage,
    },
    {
        path: '/main/change/',
        component: ChangePreferences,
    },
    {
        path: '/main/mix-week',
        component: MixWeekPage,
    },
    {
        path: '/main/popular-mixes',
        exact: true,
        component: MainPopularMixes,
    },
    {
        path: '/main/popular-mixes/:id',
        component: MainPopularMix,
    },
    {
        path: '/main/list-compilation/:id',
        component: ListMixesCompilationPage,
    },
    {
        path: '/main/compilation/:id',
        exact: true,
        component: MainListCompilation,
    },
    {
        path: '/main/compilation/mix/:id',
        component: MainMixCompilation,
    },
    {
        path: '/main/for-you/:id',
        component: ForYouMix,
    },
    {
        path: '/mixer',
        exact: true,
        component: MixerMainPage,
    },
    {
        path: '/mixer/random-mix',
        component: MixerRandomMix,
    },
    {
        path: '/mixer/brands',
        exact: true,
        component: MixerCatalogBrands,
    },
    {
        path: '/mixer/brands/:id',
        component: TastesBrandContainer,
    },
    {
        path: '/mixer/mixer-now',
        component: MixerNowContainer,
    },
    {
        path: '/mixer/result',
        exact: true,
        component: MixerResultContainer,
    },
    {
        path: '/mixer/result/:id',
        component: MixerMixPage,
    },
    {
        path: '/mixer/preferences',
        component: SelectionPreferences,
    },
    {
        path: '/mixer/pref-mix',
        exact: true,
        component: MixerPreferencesContainer,
    },
    {
        path: '/mixer/pref-mix/:id',
        component: MixPreferencesPage,
    },
    {
        path: '/favorite',
        exact: true,
        component: FavoriteContainer,
    },
    {
        path: '/favorite/:id',
        component: FavoriteMixPage,
    },
    {
        path: '/main/change-pref',
        component: ForYouPreferences,
    },
    {
        path: '/main/shared-mix/:id',
        component: SharedMix,
    },

];
